module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-11.3bc546df.jpg";